/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { colors } from "../../constants/colors";
import { useHasPermission } from "../../hooks/useHasPermission";

/* Components */
import UCButton from "../buttons";
import { ReactComponent as PaymentIcon } from "../../resources/images/aa-payment-rounded.svg"
import {useUserContext} from "../../contexts/userContext";

/* Styles */
import styles from "./styles.js"



const PaymentHeader = ({addPayment}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const { checkPermission } = useHasPermission();
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  return (
    <div className={classes.paymentWrapper}>
      <div className={classes.logo}>
          <PaymentIcon/>
      </div>
      <h1><FormattedMessage id={`paymentNoPayments.title.${providerCode}`}/></h1>
      <p><FormattedMessage id={`paymentNoPayments.description.${providerCode}`}/></p>
      {
        checkPermission("F_CREATE_PAYMENT") &&
          <UCButton
            type="primary"
            onClick={() => addPayment("addPaymentGridSpinner")}
            className={classes.addPaymentBtn}
            text={<FormattedMessage id={`paymentNoPayments.addPaymentButton.${providerCode}`}/>}
            spinner={{
              name: "addPaymentGridSpinner",
              size: 20,
              color: colors.white
            }}
          />
      }
    </div>
  )
}

export default PaymentHeader;
